module.exports = __webpack_public_path__ + "img/w3_olja_white.b87d620a.png";